import { Injectable } from '@angular/core';
import { Http, RequestOptions, RequestOptionsArgs, Response, ConnectionBackend } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { SlimLoadingBarService } from 'ng2-slim-loading-bar';

@Injectable()
export class EventHttpService extends Http {
    private currentRequests: number = 0;

    public constructor(_backend: ConnectionBackend, _defaultOptions: RequestOptions, private loadingBar: SlimLoadingBarService) {
        super(_backend, _defaultOptions);
    }

    public get(url: string, options?: RequestOptionsArgs): Observable<Response> {
        this.incrementRequestCount();
        var response = super.get(url, options);
        response.subscribe(null, error => {
            this.decrementRequestCount();
        }, () => {
            this.decrementRequestCount();
        });
        return response;
    }

    private decrementRequestCount() {
        if (--this.currentRequests == 0) {
            this.loadingBar.complete();
        }
    }

    private incrementRequestCount() {
        if (this.currentRequests++ == 0) {
            this.loadingBar.start();
        }
    }
}


// WEBPACK FOOTER //
// ./app/services/event.http.service.ts